import { payOrder } from 'ui/api/orders';
import { handleRazorpay } from './razorpay';
import { handleStripe } from './stripe';
import { handleMidTrans } from './midTrans';
import { handlePaytm } from './paytm';
import { handleCashfree } from './cashFree';

export async function initiatePay(shop, id, modeData, paymentDetails, helpers) {
  const paymentData = {
    returnUrl: helpers.getSuccessUrl(),
    cancelUrl: helpers.getCancelUrl(),
    platform: 'web',
  };

  const data = await payOrder(id, {
    mode: modeData.mode,
    subMode: modeData.subMode,
    paymentDetails,
    ...paymentData
  });

  const isPartialCod = modeData.mode === 'cod' && modeData.subMode === 'online';

  if (modeData.mode !== 'online' && !isPartialCod) {
    helpers.setSubmit(true);
    return;
  }

  return initiateOnlinePayment(shop, data, helpers);
}

export async function initiateOnlinePayment(shop, paymentData, helpers) {
  const {
    identifier,
    ...data
  } = paymentData;

  switch (identifier) {
    case 'razorpay':
      return handleRazorpay(shop, data, helpers);
    case 'stripe':
      return handleStripe(shop, data);
    case 'paypal':
      document.location.href = data.url;
      return;
    case 'phonepe':
      document.location.href = data.redirectUrl;
      return;
    case 'flutterwave':
    case 'paystack':
    case 'moncash':
      document.location.href = data.redirectUrl;
      return;
    case 'midtrans':
      return handleMidTrans(shop, data, helpers);
    case 'paytm':
      return handlePaytm(shop, data);
    default:
      return handleCashfree(shop, data);
  }
}

const Payments = {
  initiatePay,
  initiateOnlinePayment,
};

export default Payments;

